// Models
import { Block } from "shared/model";

export class GridStorage {
    public static grid: Block[][];
}